import React from 'react';
import { humanCalculators_En, healthCalculators_En, islamicCalculators_En,physicsCalculators_En, womenCalculators_En, mathCalculators_En,studyCalculators_En,financialCalculators_En,TimeArticles_En } from './ConstantsEN';
import { CalculatorsType } from '../En/ConstantsEN';
function MainCalculatorsList(props) {
  const CalculatorsTypeId = props.CalculatorsTypeId;
  let calculatorsList;
  let calculatorName;
  switch (CalculatorsTypeId) {
    case CalculatorsType.humanCalculators:
      calculatorsList = humanCalculators_En;
      calculatorName = "Time and Date Calculators";
      break;
    case CalculatorsType.healthCalculators:
      calculatorsList = healthCalculators_En;
      calculatorName = "Health and Fitness Calculators";
      break;
    case CalculatorsType.islamicCalculators:
      calculatorsList = islamicCalculators_En;
      calculatorName = "Zakat Calculators";
      break;
    case CalculatorsType.womenCalculators:
      calculatorsList = womenCalculators_En;
      calculatorName = "Women's Calculators";
      break;
    case CalculatorsType.studyCalculators:
      calculatorsList = studyCalculators_En;
      calculatorName = "Study Calculators";
      break;
      case CalculatorsType.financialCalculators:
        calculatorsList = financialCalculators_En;
        calculatorName = "Financial Calculators";
      break;
      case CalculatorsType.mathCalculators:
        calculatorsList = mathCalculators_En;
        calculatorName = "Math Calculatosr";
      break;
      case CalculatorsType.physicsCalculators:
        calculatorsList = physicsCalculators_En;
        calculatorName = "Physics Calculator";
      break;
      case CalculatorsType.TimeArticles_En:
        calculatorsList = TimeArticles_En;
        calculatorName = "Time Articles";
      break;
    default:
      calculatorsList = humanCalculators_En;
      calculatorName = "Date and Time Calculators";
      break;
  }
  return (
    <div>
      <div className="bg-success text-white text-center" style={{ height: '40px' }}>
        <b>{calculatorName}</b>
      </div>
      <div className="border border-light">
        <ul>
          {calculatorsList.map((item, index) => (
            <li key={index}>
                             <a href={item.link} className="item-link">
                {item.name}
              </a>
            </li>
          ))}
        </ul>
         </div>
</div>
  );
}
export default MainCalculatorsList;
